import React from 'react';

import Modal from '~components/Modal';
import { Form as WizardForm } from '~components/wizard-form';

import steps from '~support-at-home/forms/reconciliations/new';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: (toggle: boolean) => void;
}

const Wizard: React.FC<ComponentProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="New Reconciliation"
      className="reconciliation-wizard-modal"
      headerClassName="header"
      contentClassName="wizard-modal"
      includeFooter={false}
      unmountOnClose
    >
      <WizardForm steps={steps} onComplete={() => setIsOpen(false)} submitCaption="Close" />
    </Modal>
  );
};

export default Wizard;
